export default __webpack_public_path__ + "static/media/fasting_unexpected@2x.7e8b7bec.jpg";